<template>
  <div class="flexbox container">
    <img class="img_icon" src="../../../../images/subVIp/success.png" alt="" />
    <div class="success_text">{{ id ? '提交' : '支付' }}成功</div>
    <div class="message">
      {{
        id ? '您已重新提交成功' : '您已成功购买家庭卡'
      }}，班主任将在24小时内完成审核。审核通过后，将会短信通知您并开通家庭卡权益，请耐心等待。
    </div>
    <div @click="closeWin" class="btn_box">关闭</div>
  </div>
</template>

<script>
// import { storage } from '@/utils'
export default {
  data() {
    return {
      id: null
    }
  },
  created() {
    this.id = this.$route.query.id
  },
  mounted() {},
  methods: {
    /** 关闭微信浏览器 */
    closeWin() {
      // 微信浏览器里有一个 WeixinJSBridge 对象，就像普通浏览器里必有 window 对象一样，无需额外引入
      // 不过保险起见，还是判断一下是否为空
      // eslint-disable-next-line no-undef
      if (WeixinJSBridge?.invoke) {
        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke('closeWindow', {}, () => {
          console.error('关闭微信网页失败')
        })
      }
      window.close()
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  flex-direction: column;
  .img_icon {
    width: 0.88rem;
    height: 0.88rem;
    display: block;
    margin-top: 1.38rem;
  }
  .success_text {
    font-size: 0.36rem;
    font-weight: 600;
    padding: 0.32rem 0 0.58rem;
  }
  .message {
    padding: 0 0.94rem;
    font-size: 0.32rem;
    font-weight: 400;
    color: #000000;
    line-height: 1.2;
  }
  .btn_box {
    width: 80%;
    text-align: center;
    background-color: #00b25a;
    border-radius: 0.3rem;
    color: #fff;
    padding: 0.22rem 0;
    margin: 1rem auto 0;
  }
}
</style>
